export enum StyleVariant {
  Primary = "Primary",
  Secondary = "Secondary",
  Danger = "Danger",
  Success = "Success",
  Warning = "Warning",
  Info = "Info",
  BlackWhite = "BlackWhite"
}

export enum SizeVariant {
  ExtraSmall = "ExtraSmall",
  Small = "Small",
  Medium = "Medium",
  Large = "Large"
}

export enum TypeVariant {
  Contained = "Contained",
  Outlined = "Outlined",
  Text = "Text"
}

export enum TextVariant {
  H1 = "H1",
  H2 = "H2",
  H3 = "H3",
  H4 = "H4",
  H5 = "H5",
  H6 = "H6",
  Subtitle1 = "Subtitle1",
  Subtitle2 = "Subtitle2",
  Body1 = "Body1",
  Body2 = "Body2",
  Button = "Button",
  Caption = "Caption",
  Overline = "Overline"
}

export enum TextWeight {
  Light = 300,
  Regular = 400,
  Medium = 500,
  Bold = 700
}

export enum ElevationVariant {
  Elevation0 = "Elevation0",
  Elevation1 = "Elevation1",
  Elevation2 = "Elevation2",
  Elevation3 = "Elevation3",
  Elevation4 = "Elevation4",
  Elevation6 = "Elevation6",
  Elevation8 = "Elevation8",
  Elevation9 = "Elevation9",
  Elevation12 = "Elevation12",
  Elevation16 = "Elevation16",
  Elevation24 = "Elevation24"
}
